var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"review\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"rating") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":6},"end":{"line":24,"column":13}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"comment") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":6},"end":{"line":30,"column":13}}})) != null ? stack1 : "")
    + "\r\n      <div class=\"author\">- "
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"author") : depth0), depth0))
    + ", "
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"date") : depth0), depth0))
    + "</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"response") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":6},"end":{"line":39,"column":15}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"top\">\r\n          <span class=\"rating\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"rating") : depth0), depth0))
    + "/10</span>\r\n        </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"comment\">\r\n          <i class=\"fas sixtysix fa-quote-left\"></i><span class=\"clamp2\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"comment") : depth0), depth0))
    + "</span><i class=\"fas nintynine fa-quote-right\"></i>\r\n        </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"response\">\r\n          <span class=\"heading\">Response from "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"author") : depth0), depth0))
    + " on "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"date") : depth0), depth0))
    + ":</span>\r\n          <p>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"comment") : depth0), depth0))
    + "</p>\r\n        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h1>Reviews</h1>\r\n\r\n<div class=\"sub\">What's being said about "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"location") : stack1), depth0))
    + "</div>\r\n\r\n<div class=\"rating-copy\">\r\n  <span class=\"overall-rating\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"overallRating") : stack1), depth0))
    + "/10</span> <span class=\"label\">Overall rating</span> <span class=\"based\">based on "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"reviewCount") : stack1), depth0))
    + " reviews.</span>\r\n</div>\r\n\r\n<div class=\"review-pro\">\r\n  <img class=\"lazyload\" data-src=\"/client/dist/images/logo-review-pro.png\" alt=\"Review Pro logo\">\r\n  <div class=\"ui tooltip\"><i class=\"fas icon fa-info\"></i></div>\r\n  <div class=\"ui popup\">\r\n    "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </div>\r\n</div>\r\n\r\n<div class=\"review-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"reviews") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":2},"end":{"line":42,"column":11}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});